import axios from "axios";

const LOCAL_API_BASE_URL = "http://localhost:8081/api/leads";
const PRODUCTION_API_BASE_URL = "/api/leads";

const API_BASE_URL =
  process.env.REACT_APP_CRM_API_URL ||
  (process.env.NODE_ENV === "production" ? PRODUCTION_API_BASE_URL : LOCAL_API_BASE_URL);

const crmApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getLeads = async (params = {}) => {
  const response = await crmApi.get("", { params });
  return response.data;
};

export const getLeadById = async (id) => {
  const response = await crmApi.get(`/${id}`);
  return response.data;
};

export const createLead = async (payload) => {
  const response = await crmApi.post("", payload);
  return response.data;
};

export const updateLeadStatus = async (id, payload) => {
  const response = await crmApi.put(`/${id}/status`, payload);
  return response.data;
};

export const deleteLead = async (id) => {
  const response = await crmApi.delete(`/${id}`);
  return response.data;
};
